import { ElegivelTapumeManutencao, TapumeManutencaoConfig } from './elegibilidade-tapume-manutencao.types';

const tapumeManutencaoConfig: TapumeManutencaoConfig = {
  marcas: ['estacio', 'wyden', 'idomed'],
};

export const elegivelTapumeManutencao: ElegivelTapumeManutencao = ({ marca }) => {
  return tapumeManutencaoConfig.marcas.includes(marca);
};
